import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import '../../styles/Membership.css';
import '../../styles/MemberModal.css';
import config from '../../constants/config';
import GoogleMapReact from 'google-map-react';
import { RiArrowRightSLine, RiCloseLine } from 'react-icons/ri';
import { FaGlobe, FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import Marker from '../../components/Marker';
import MembersMap from '../../components/MembersMap';
import axiosPost from '../../helper/axios-helper';

export default function MembershipListing() {

  const faqRefsMembership = useRef({});
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [loading, setLoading] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showModal, setShowModal] = useState(false);
  
  // Function to fetch countries with members from the API
  const fetchCountriesMembers = () => {
    setLoading(true);
    axiosPost('members/countries/fetch', {}, {}, (data) => {
      const { success, response } = data;
      if (success) {
        setCountries(data.data);
        console.log('Countries with members fetched:', data.data);
      } else {
        console.log('Error fetching countries with members:', response);
      }
      setLoading(false);
    });
  };

  // Function to fetch members from the API
  const fetchMembers = () => {
    setLoading(true);
    axiosPost('admin/members/fetch', {}, {}, (data) => {
      const { success, response } = data;
      if (success) {
        setMembers(data.data);
        console.log('Members fetched:', data.data);
      } else {
        console.log('Error fetching members:', response);
      }
      setLoading(false);
    });
  };
  
  // Fetch data when component mounts
  useEffect(() => {
    fetchCountriesMembers();
    fetchMembers();
  }, []);

  const [members, setMembers] = useState([]);

  const [membersOld, setMembersOld] = useState([
    {
      id: 1,
      member: "Digicel Anguilla",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "Anguilla",
      link: ""
    },
    {
      id: 2,
      member: "Digicel - Aruba",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "Aruba",
      link: ""
    },
    {
      id: 3,
      member: "Digicel - Bermuda",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "Bermuda",
      link: ""
    },
    {
      id: 4,
      member: "Digicel - Bonaire",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "Bonaire",
      link: ""
    },
    {
      id: 5,
      member: "Digicel BVI",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "BVI",
      link: ""
    },
    {
      id: 6,
      member: "Digicel Cayman Ils",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "Cayman Ils",
      link: ""
    },
    {
      id: 7,
      member: "Digicel Dominica",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "Dominica",
      link: "https://logowik.com/content/uploads/images/digicel5375.jpg"
    },
    {
      id: 8,
      member: "Digicel - Grenada",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "Grenada",
      link: ""
    },
    {
      id: 9,
      member: "Digicel St. Kitts & Nevis",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "St. Kitts-Nevis",
      link: ""
    },
    {
      id: 10,
      member: "Digicel St. Lucia",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "St. Lucia",
      link: ""
    },
    {
      id: 11,
      member: "Digicel St. Vincent",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "St. Vincent",
      link: ""
    },
    {
      id: 12,
      member: "Digicel - Turks & Caicos",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "TCI",
      link: ""
    },
    {
      id: 13,
      member: "Digicel - Trinidad",
      member_type: "Full Member",
      member_logo: "https://logowik.com/content/uploads/images/digicel5375.jpg",
      country: "Trinidad",
      link: ""
    },
    {
      id: 14,
      member: "Antigua Public Utilities Authority",
      member_type: "Full Member",
      member_logo: "",
      country: "Antigua",
      link: ""
    },
    {
      id: 15,
      member: "Belize Telemedia Ltd.",
      member_type: "Full Member",
      member_logo: "",
      country: "Belize",
      link: ""
    },
    {
      id: 16,
      member: "BTC",
      member_type: "Full Member",
      member_logo: "",
      country: "Bahamas",
      link: ""
    },
    {
      id: 17,
      member: "C&W Anguilla",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "Anguilla",
      link: ""
    },
    {
      id: 18,
      member: "C&W Antigua & Barbuda",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "Antigua",
      link: ""
    },
    {
      id: 19,
      member: "C&W - Barbados",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "Barbados",
      link: ""
    },
    {
      id: 20,
      member: "C&W BVI",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "BVI",
      link: ""
    },
    {
      id: 21,
      member: "C&W Cayman",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "Cayman Ils.",
      link: ""
    },
    {
      id: 22,
      member: "C&W Dominica",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "Dominica",
      link: ""
    },
    {
      id: 23,
      member: "C&W Grenada",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "Grenada",
      link: ""
    },
    {
      id: 24,
      member: "C&W Jamaica",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "Jamaica",
      link: ""
    },
    {
      id: 25,
      member: "C&W Panama",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "Panama",
      link: ""
    },
    {
      id: 26,
      member: "C&W ST. Kitts - Nevis",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "St. Kitts-Nevis",
      link: ""
    },
    {
      id: 27,
      member: "C&W ST. Lucia",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "St. Lucia",
      link: ""
    },
    {
      id: 28,
      member: "C&W ST. Vincent",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "St. Vincent",
      link: ""
    },
    {
      id: 29,
      member: "C&W TCI",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "TCI",
      link: ""
    },
    {
      id: 30,
      member: "C&W Communications",
      member_type: "Full Member",
      member_logo: "https://www.whoswhotnt.com/wp-content/uploads/2019/10/CW-logo-1.jpg",
      country: "USA",
      link: ""
    },
    {
      id: 31,
      member: "Columbus Communications Trinidad",
      member_type: "Full Member",
      member_logo: "",
      country: "Trinidad",
      link: ""
    },
    {
      id: 32,
      member: "Cable Bahamas",
      member_type: "Full Member",
      member_logo: "",
      country: "Bahamas",
      link: ""
    },
    {
      id: 33,
      member: "Guyana T&T co.",
      member_type: "Full Member",
      member_logo: "",
      country: "Guyana",
      link: ""
    },
    {
      id: 34,
      member: "ALIV",
      member_type: "Full Member",
      member_logo: "",
      country: "Bahamas",
      link: ""
    },
    {
      id: 35,
      member: "SETAR",
      member_type: "Full Member",
      member_logo: "",
      country: "Aruba",
      link: ""
    },
    {
      id: 36,
      member: "Speednet",
      member_type: "Full Member",
      member_logo: "",
      country: "Belize",
      link: ""
    },
    {
      id: 37,
      member: "TELEM",
      member_type: "Full Member",
      member_logo: "",
      country: "St. Maarten",
      link: ""
    },
    {
      id: 38,
      member: "Telesur",
      member_type: "Full Member",
      member_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAFc56WTxfp95Xg8p0euOsKrF2TVBoZYhrxUJmOXchAnvRzaGOrDIaRX-6Tc_2sBxvjXI&usqp=CAU",
      country: "Suriname",
      link: ""
    },
    {
      id: 39,
      member: "TSTT",
      member_type: "Full Member",
      member_logo: "",
      country: "Trinidad",
      link: ""
    },
    {
      id: 40,
      member: "UTS",
      member_type: "Full Member",
      member_logo: "",
      country: "Curacao",
      link: ""
    },
    {
      id: 41,
      member: "Atlantic Tele-Network",
      member_type: "Full Member",
      member_logo: "",
      country: "USA",
      link: ""
    },
    {
      id: 42,
      member: "Innovative Telephone Corporation (Viya)",
      member_type: "Full Member",
      member_logo: "",
      country: "USVI",
      link: ""
    },
    {
      id: 43,
      member: "ETECSA",
      member_type: "Full Member",
      member_logo: "",
      country: "Cuba",
      link: ""
    },
    {
      id: 44,
      member: "Datasur",
      member_type: "Full Member",
      member_logo: "",
      country: "Suriname",
      link: ""
    },
    {
      id: 45,
      member: "WestTel Limited (Logic)",
      member_type: "Full Member",
      member_logo: "",
      country: "Cayman Ils.",
      link: ""
    },
    {
      id: 46,
      member: "One Communications Ltd",
      member_type: "Full Member",
      member_logo: "",
      country: "Bermuda",
      link: ""
    },
    {
      id: 47,
      member: "E-Net",
      member_type: "Full Member",
      member_logo: "",
      country: "Guyana",
      link: ""
    },
    {
      id: 48,
      member: "Bridgevoice (Bankai)",
      member_type: "Full Member",
      member_logo: "",
      country: "USA",
      link: ""
    },
    {
      id: 49,
      member: "Amdocs Management",
      member_type: "Affiliate Member",
      member_logo: "",
      country: "",
      link: ""
    },
    {
      id: 50,
      member: "Apple Inc.",
      member_type: "Affiliate Member",
      member_logo: "",
      country: "USA",
      link: ""
    }
  ]);

  // membersLocation is now derived from members data
  const membersLocation = useMemo(() => {
    return members.filter(member => member.latitude && member.longitude).map(member => ({
      id: member.id,
      name: member.name,
      image: member.image,
      phone: member.phone,
      email: member.email,
      location: {
        lat: parseFloat(member.latitude),
        lng: parseFloat(member.longitude)
      }
    }));
  }, [members]);

  const [countries, setCountries] = useState([])

  const [query, setQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  // Update search results when membersLocation changes
  useEffect(() => {
    setSearchResults(membersLocation);
  }, [membersLocation]);

  const [ storeSelected, setStoreSelected ] = useState(null);

  const defaultMapData = {
    center: {
      lat: 10.46592178695602, 
      lng: -61.84375298890373
    },
    zoom: 2
  };
  const [ mapData, setMapData ] = useState(defaultMapData);
  const map = useRef();

  const mapObjects = (membersLocation).map( (store, index) => {

    const location = store.location;

    if(!location) return false;

    return (
      <div
        key={'store_map_' + store.id}
        className="StoreMarkerWrapper"
        lat={ location.lat }
        lng={ location.lng }
      >
        <div className="StoreMarker">
          <div className="StoreMarkerImage">
            <img src={process.env.PUBLIC_URL + store.image} draggable={false} />
          </div>
        </div>
        <div className="StoreMarkerLeg" />
      </div>
    )
  });

  const scrollMapToPosition = (location) => {

    if(location){

      setMapData({
        center: {
          lat: location.lat,
          lng: location.lng
        },
        zoom: 12
      });


    }else{

      setMapData(defaultMapData)
    }
  }

  const storesSorted = searchResults;

  const mapListObjects = (storesSorted).map( (store, index) => {

    const location = store.location;
    const isSelected = (storeSelected && storeSelected.name == store.name);

    return (
      <div
        key={'store_list_' + store.id}
        className={`StoreItemWrapper ${ (isSelected) ? 'Selected' : ''}`}
        lat={ (location) ? location.lat : '' }
        lng={ (location) ? location.lng : '' }
        onMouseEnter={
          () => {
            scrollMapToPosition(location);
            setStoreSelected(store);
          }
        }
      >
        <div className="StoreItem">
          <div className="StoreItemImage" style={{ backgroundImage: `url(${store.image})` }}></div>
          <div className="StoreItemDetails">
            <div className="StoreItemDetailsTitle">{ store.name }</div>
            <div className="StoreItemDetailsContact">{ store.phone }</div>
          </div>
          <RiArrowRightSLine />
        </div>

      </div>
    )
  });

  const searchByName = (query, membersList) => {
    return membersList.filter(member =>
      member.name && member.name.toLowerCase().includes(query.toLowerCase())
    );
  };

  const handleSearch = (event) => {
    const input = event.target.value;
    setQuery(input);
    const results = searchByName(input, membersLocation);
    setSearchResults(results);
  };

  const filteredMembers = useMemo(() => {
    return members.filter(member => 
      (selectedFilter === 'all' || member.member_type === selectedFilter)
    );
  }, [selectedFilter, members]);

    const MemberModal = ({ member, onClose }) => {
      if (!member) return null;

      return (
        <div className='member-modal-overlay' onClick={onClose}>
          <div className='member-modal-content' onClick={(e) => e.stopPropagation()}>
            <button className='member-modal-close' onClick={onClose}>
              <RiCloseLine size={24} />
            </button>
            
            <div className='member-modal-header'>
              <div className='member-modal-image' style={{backgroundImage: `url(${member.image})`}}></div>
              <div className='member-modal-header-info'>
                <h2>{member.name}</h2>
                <div className='member-modal-type'>{member.member_type}</div>
                {member.country && (
                  <div className='member-modal-country'>
                    {member.country_flag && <img src={member.country_flag} alt={member.country} className='member-modal-flag' />}
                    <span>{member.country}</span>
                  </div>
                )}
              </div>
            </div>

            <div className='member-modal-body'>
              {member.phone && member.phone.trim() !== '' && (
                <div className='member-modal-info-item'>
                  <FaPhone className='member-modal-icon' />
                  <a href={`tel:${member.phone}`}>{member.phone}</a>
                </div>
              )}
              
              {member.email && member.email.trim() !== '' && (
                <div className='member-modal-info-item'>
                  <FaEnvelope className='member-modal-icon' />
                  <a href={`mailto:${member.email}`}>{member.email}</a>
                </div>
              )}
              
              {member.website && member.website.trim() !== '' && (
                <div className='member-modal-info-item'>
                  <FaGlobe className='member-modal-icon' />
                  <a href={member.website} target='_blank' rel='noopener noreferrer'>{member.website}</a>
                </div>
              )}

              {((member.facebook_link && member.facebook_link.trim() !== '') || 
                (member.instagram_link && member.instagram_link.trim() !== '') || 
                (member.linkedin_link && member.linkedin_link.trim() !== '')) && (
                <div className='member-modal-social'>
                  <h3>Connect with us</h3>
                  <div className='member-modal-social-links'>
                    {member.facebook_link && member.facebook_link.trim() !== '' && (
                      <a href={member.facebook_link} target='_blank' rel='noopener noreferrer' className='member-modal-social-link'>
                        <FaFacebook size={24} />
                      </a>
                    )}
                    {member.instagram_link && member.instagram_link.trim() !== '' && (
                      <a href={member.instagram_link} target='_blank' rel='noopener noreferrer' className='member-modal-social-link'>
                        <FaInstagram size={24} />
                      </a>
                    )}
                    {member.linkedin_link && member.linkedin_link.trim() !== '' && (
                      <a href={member.linkedin_link} target='_blank' rel='noopener noreferrer' className='member-modal-social-link'>
                        <FaLinkedin size={24} />
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    };

    const RenderMemberTable = ({ data }) => {

        return (
        <div className="members-table-container">
            <div className='members-table-row header'>
            <div className='members-table-row-item w-300'>Member</div>
            <div className='members-table-row-item w-200'>Membership Type</div>
            <div className='members-table-row-item w-flexed'>Country</div>
            </div>

            { filteredMembers.map((member, index) => {
            return (
                <div className='members-table-row'>

                  <div className='members-table-row-item w-300'>
                    <div className='members-table-row-image' style={{backgroundImage: `url(${member.image})`}}></div>
                    {member.name}
                  </div>

                  <div className='members-table-row-item w-200'>
                    {member.member_type}
                  </div>

                  <div className='members-table-row-item w-flexed'>
                    {member.country}
                  </div>
                  
                  <div className='members-table-row-item'>
                    <div 
                      className='members-table-tow-item-btn'
                      onClick={() => {
                        setSelectedMember(member);
                        setShowModal(true);
                      }}
                    >
                      Learn More
                    </div>
                  </div>
                </div>
            )
            })

            }
        </div>
        )

    }

    const mapView = useCallback(() => {
      
      
      return (
        <div className='membersMap'>
          <GoogleMapReact
            ref={map}
            bootstrapURLKeys={{ key: config.google.api }}
            center={mapData.center}
            zoom={mapData.zoom}
            options={{
            styles: config.google.style,
            fullscreenControl: false,
            zoomControl: true,
            clickableIcons: false
          }}
          >
           
          </GoogleMapReact>
        </div>
      )

    })

  return (
    <div className='container' style={{marginTop: '100px'}}>
        {showModal && <MemberModal member={selectedMember} onClose={() => setShowModal(false)} />}
        <div style={{margin: '25px 0'}}>
          <div className='membersMapContainer'>
            <MembersMap countries={countries} />

          </div>


          <div className='members-table-header'>
            <div style={{flex: 1}}>Meet our Members</div>

            <div className="filter-section" style={{fontSize: '14px', margin: 0}}>
                <h3>Filter Members</h3>
                <select 
                value={selectedFilter} 
                onChange={(e) => setSelectedFilter(e.target.value)}
                >
                <option value="all">All Members</option>
                <option value="Full Member">Full Members</option>
                <option value="Affiliate Member">Affiliate Members</option>
                </select>
            </div>
          </div>
          <RenderMemberTable data={members} />
        </div>
    </div>
  )
}
